import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import routes from "../routes";

const Footer = () => {
  const { t } = useTranslation(); // Destructure the t function
  return (
    <footer className="bg-[#1f2630] text-white py-8">
      {/* Quote Section */}
      <div className="px-[50px]  bg-gray-100 text-center py-2 text-sm text-gray-800 ">
        &quot;{t("footerSection.sentence.s1")}
        <span className="text-[rgb(193_119_112)] font-medium ">
          {t("footerSection.sentence.s2")}
        </span>{" "}
        {t("footerSection.sentence.s3")}&quot;
      </div>

      {/* Main Footer */}
      <div className="pt-[2rem]  max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-6 grid grid-cols-1 md:grid-cols-3 gap-6 items-start">
        {/* Logo + Links */}
        <div className="text-center md:text-left order-2 md:order-none">
          <h2 className="text-2xl font-semibold text-white">
            <span className="text-[rgb(193_119_112)]">C</span>ross{" "}
            <span className="text-[rgb(193_119_112)]">B</span>order
          </h2>
          <nav className="mt-4 flex gap-4 text-sm justify-center md:justify-start">
            <Link
              to={routes.products}
              className="hover:text-[rgb(193_119_112)] bg-transparent border-none cursor-pointer"
            >
              {t("footerSection.lists.l1")}
            </Link>
            <Link
              to={routes.aboutUs}
              className="hover:text-[rgb(193_119_112)] bg-transparent border-none cursor-pointer"
            >
              {t("footerSection.lists.l2")}
            </Link>
            <Link
              to={routes.contactUs}
              className="hover:text-[rgb(193_119_112)] bg-transparent border-none cursor-pointer"
            >
              {t("footerSection.lists.l3")}
            </Link>
          </nav>
          <p className="mt-4 text-sm text-[rgb(193_119_112)]">
            Copyright © 2026 Cross Border - All Rights Reserved.
          </p>
        </div>

        {/* Contact Info */}
        <div className="justify-items-center lg:justify-items-start md:pt-[0.3rem] text-sm space-y-2 order-3 md:order-none">
          <p className="flex items-center gap-2">
            <span>📍</span> Istanbul, Türkiye
          </p>
          <p className="flex items-center gap-2">
            <span>📞</span> +90 (552) 551 05 95
          </p>
          <p className="flex items-center gap-2">
            <span>📧</span>{" "}
            <a
              href={`mailto:${process.env.REACT_APP_SALES_EMAIL || "info@crossborder-store.com"}`}
              className="text-[rgb(193_119_112)] hover:underline"
            >
              {process.env.REACT_APP_SALES_EMAIL ||
                "info@crossborder-store.com"}
            </a>
          </p>
        </div>

        {/* About + Socials */}
        <div className="order-1 md:order-none md:text-left text-center">
          <h3 className="text-white text-sm font-semibold mb-2">
            {t("footerSection.about.header")}{" "}
            <span className="text-[rgb(193_119_112)]">Cross Border</span>
          </h3>
          <p className="text-sm text-gray-300">
            {t("footerSection.about.body")}
          </p>
          <div className="flex gap-4 mt-4 text-xl md:text-left text-center justify-center md:justify-start">
            <button
              onClick={(e) => e.preventDefault()}
              className="hover:text-[rgb(193_119_112)] bg-transparent border-none cursor-pointer"
              aria-label="Instagram"
            >
              📷
            </button>
            <button
              onClick={(e) => e.preventDefault()}
              className="hover:text-[rgb(193_119_112)] bg-transparent border-none cursor-pointer"
              aria-label="LinkedIn"
            >
              💼
            </button>
            <button
              onClick={(e) => e.preventDefault()}
              className="hover:text-[rgb(193_119_112)] bg-transparent border-none cursor-pointer"
              aria-label="YouTube"
            >
              📺
            </button>
            <button
              onClick={(e) => e.preventDefault()}
              className="hover:text-[rgb(193_119_112)] bg-transparent border-none cursor-pointer"
              aria-label="GitHub"
            >
              💻
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; // Default export
